<template>
  <v-dialog content-class="cart-modal-style" v-model="show" max-width="1400">
    <v-card v-if="loading" dark pa-5 color="primary" class="pa-5">
      <div class="text-center pb-3">please wait</div>
      <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
    </v-card>
    <div v-if="!loading" class="pa-2">
      <v-container grid-list-md>
        <v-sheet class="d-flex pa-4 grey lighten-4 primary--text">
          <v-layout>
            <v-flex>
              <b>Cart Id :</b>
              {{cart.cartSpecialId}}
            </v-flex>
            <v-flex>
              <b>Current State :</b>
              {{cart.stateName}}
            </v-flex>
            <v-flex>
              <b>Current Location :</b>
              {{cart.locationName}}
            </v-flex>
          </v-layout>
        </v-sheet>
      </v-container>
      <div class="pa-2">
        <ADataTable
          :headers="headers"
          :api="api"
          :title="'Scan Log'"
          :sortBy="'Timestamp'"
          :sortDesc="true"
          :hideTitleBar="true"
          :apiParams="apiParams"
          :exportable="true"
          ref="table"
        />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import CartsLogMixin from "../mixins/CartsLog";
import CRUDFuncsMixin from "../mixins/CRUDFuncs";
import ADataTable from "./ADataTable";
import cartApi from "../api/cart";

export default {
  name: "CartModal",
  mixins: [CartsLogMixin, CRUDFuncsMixin],
  components: {
    ADataTable
  },
  data() {
    return {
      model: "cartscanlog",
      cartId: "",
      show: false,
      cart: {},
      loading: false
    };
  },
  computed: {
    apiParams: function() {
      return {
        cartId: this.cartId
      };
    }
  },
  methods: {
    reset() {
      (this.cartId = ""), (this.status = ""), (this.location = "");
    },
    open(cartId) {
      this.show = true;
      this.cartId = cartId;
      this.loadCart();
    },
    loadCart(cartId) {
      this.loading = true;
      cartApi.get(this.cartId, data => {
        this.cart = data.d;
        this.loading = false;
      });
    }
  },
  watch: {
    show: function() {
      if (!this.show) {
        this.reset();
      }
    }
  }
};
</script>

<style>
.cart-modal-style {
  background-color: white;
}
</style>
